export default {
  addPage: {
    scan: "Seite fotografieren",
    upload: "Seite hochladen",
    zoomIn: "Vergrößern",
    zoomOut: "Verkleinern"
  },
  bucketType: {
    standalone: "Beleg",
    trip: "Reise"
  },
  cancel: "Abbrechen",
  close: "Schließen",
  common: {
    system: "System",
    "system-ai": "KI",
    "system-migration": "Migration"
  },
  dismiss: "Schließen",
  distanceUnit: {
    km: "km"
  },
  dropZone: {
    allowedTypes: "Zulässige Dateitypen: Bilder und PDFs",
    drop: "Dateien zum Hochladen ablegen"
  },
  duplicate: {
    receipt: {
      accept: {
        accept: "Ja, ich bin mir sicher.",
        areYouSure: "Sind Sie sicher, dass dies kein Duplikat ist?",
        placeholder: "(Optional) Geben Sie einen Grund an"
      },
      accepted: {
        acceptedBy: "Als kein Duplikat markiert durch {name}",
        hideDetails: "Details ausblenden",
        reviewedBy: "Überprüft durch {name}",
        showDetails: "Details anzeigen",
        title: "Mögliches Duplikat behoben"
      },
      file: {
        message: "Eine Datei, die mit #{index} identisch ist, wurde bereits hochgeladen:"
      },
      ofOwner: "von {ownerName}",
      receipt: "Beleg {name}",
      refresh: "Erneut prüfen",
      reset: "Duplikate zurücksetzen",
      review: {
        accept: "Als geprüft markieren",
        areYouSure: "Können Sie bestätigen, dass dies kein Duplikat ist?",
        placeholder: "(Optional) Geben Sie einen Grund an"
      },
      similar: {
        message: "Es gibt bereits einen Beleg mit denselben Daten:"
      },
      title: "Mögliches Duplikat gefunden",
      trip: "Reise {name}"
    },
    trip: {
      item: "Beleg {id}",
      message: "Diese Belege wurden möglicherweise bereits eingereicht",
      title: "Mögliche Duplikate gefunden"
    }
  },
  email: {
    button: "{context} anzeigen",
    comment: {
      action: "{author} hat einen Kommentar hinzugefügt"
    },
    reason: {
      base: "Sie erhalten diese E-Mail, weil Sie {reason} sind",
      owner: "der Besitzer dieses Vorgangs",
      relation: "{relation} von {ofUserName}",
      role: "Rolle {role}"
    },
    transitionBackward: {
      action: "Wurde zurück auf {state} gesetzt",
      description: "Wurde von {author} aus dem Status {fromState} verschoben"
    },
    transitionForward: {
      action: "Ist bereit für {state}",
      completed: "Ist abgeschlossen",
      description: "Wurde von {author} aus dem Status {fromState} verschoben"
    }
  },
  error: "Es ist ein Fehler aufgetreten:",
  errors: {
    errorCode: {
      maintenance: "Die Anwendung ist derzeit im Wartungsmodus. Bitte versuchen Sie es später erneut.",
      "unsupported-file-type": "Der hochgeladene Dateityp wird nicht unterstützt. Bitte laden Sie eine andere Datei hoch.",
      "validation-error": "Es sind Validierungsfehler aufgetreten. Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut."
    },
    genericServerError: "Der Server antwortete mit dem Code {statusCode}. Bitte versuchen Sie es später erneut.",
    statusCode: {
      "400": "Ungültige Anfrage – Der Server konnte die Anfrage aufgrund einer ungültigen Syntax nicht verarbeiten.",
      "401": "Nicht autorisiert – Sie sind nicht berechtigt, diese Aktion auszuführen. Bitte melden Sie sich an.",
      "403": "Nicht erlaubt – Sie haben keine Berechtigung, diese Aktion auszuführen.",
      "404": "Nicht gefunden – Die angeforderte Ressource wurde nicht gefunden.",
      "500": "Serverfehler – Es ist ein interner Serverfehler aufgetreten. Bitte versuchen Sie es später erneut."
    }
  },
  expenses: {
    breakfast: "Frühstück",
    businessExpenses: "Spesen",
    country: "Land (Stadt)",
    day: "Tag",
    daySum: "Tagessumme",
    dinner: "Abendessen",
    endDate: "Enddatum",
    explainMeal: "Setzen Sie ein Häkchen für jede Mahlzeit, die Sie von der Firma erhalten haben. Sie werden von den Spesen abgezogen.",
    explainPrivateStay: "Setzen Sie ein Häkchen für jede Übernachtung, die nicht vom Unternehmen bezahlt wird (z. B. Übernachtung bei Familie/Freunden). Den Reisekosten wird eine Pauschale hinzugefügt.",
    lunch: "Mittagessen",
    mealsPaidByEmployer: "Bitte wählen Sie die vom Arbeitgeber bezahlten Mahlzeiten aus.",
    privateStay: "Privatübernachtung",
    startDate: "Startdatum",
    sum: "Summe",
    totalSum: "Summe"
  },
  expensesEditor: {
    header: "Spesen bearbeiten"
  },
  expensesListEntry: {
    excludedMeals: "Von der Firma bezahlte Mahlzeiten",
    privateStays: "Private Übernachtungen",
    title: "Spesen"
  },
  extractedInformation: {
    analyze: "Analysieren",
    estimatedCosts: "Geschätzte Kosten: {estimatedCost} Cent",
    field: {
      countryCode: "Land",
      date: "Datum",
      item: "Posten {index, number}",
      type: "Belegtyp"
    },
    title: "KI-extrahierte Informationen"
  },
  field: {
    company: "Firma",
    countryCode: "Land",
    date: "Datum",
    deductions: "Verpflegungsabzüge",
    description: "Beschreibung",
    distance: {
      locationFrom: "Von",
      locationTo: "Nach",
      unit: "Einheit",
      value: "Entfernung",
      vehicleType: "Fahrzeug"
    },
    duplicates: "Mögliche Duplikate",
    endedOn: "Rückkehr",
    files: "Dateien",
    iban: "IBAN",
    items: "Posten",
    locationFrom: "Von",
    locationTo: "Nach",
    mealParticipants: "Teilnehmer",
    name: "Name",
    owner: "Antragsteller",
    paid: "Bezahlt",
    rates: "Tagespauschalen",
    startedOn: "Abreise",
    sum: "Betrag",
    tax: "Inkl. Steuer",
    total: "Gesamt",
    travelTime: "Reisezeit",
    type: "Art",
    unit: "Einheit",
    value: "Entfernung",
    vehicleType: "Fahrzeug"
  },
  fileUploads: {
    loadingOpenCV: "Dokumentenscanner wird geladen...",
    saveAsMultiple: "Mehrere Belege",
    saveAsOne: "Ein Beleg",
    saveHowText: "Sie laden mehrere Dateien hoch. Handelt es sich um einen mehrseitigen Beleg oder um mehrere Belege?",
    uploadingNew: "Neue Belege hochladen",
    uploadingToReceipt: "Dateien zum Beleg {receiptId} hochladen",
    uploadingToTrip: "Belege für Reise {tripId} hochladen"
  },
  form: {
    noOptions: "Keine Optionen",
    previousLocations: "Frühere Orte"
  },
  general: {
    loading: "Wird geladen…"
  },
  header: {
    listView: "Listenansicht",
    newReceipt: "Neuer Beleg",
    newTrip: "Neue Reise",
    tableView: "Tabellenansicht"
  },
  history: {
    actions: {
      acceptDuplicates: "Mögliches Duplikat akzeptiert",
      addFile: "Hat {count, plural, one {eine} other {#}} {count, plural, one {Datei} other {Dateien}} hinzugefügt",
      addReceipt: "Hat {count, plural, one {einen} other {#}} {count, plural, one {Beleg} other {Belege}} hinzugefügt",
      addToTrip: "Hat den Beleg zur Reise {tripId} hinzugefügt.",
      archived: "Archiviert",
      create_receipt: "Hat den Beleg erstellt",
      create_trip: "Hat die Reise erstellt",
      reactivated: "Reaktiviert",
      removeReceipt: "Hat {count, plural, one {einen} other {#}} {count, plural, one {Beleg} other {Belege}} entfernt",
      removedFile: "Hat {count, plural, one {eine} other {#}} {count, plural, one {Datei} other {Dateien}} entfernt",
      resetDuplicates: "Duplikatsstatus zurückgesetzt",
      reviewDuplicates: "Mögliches Duplikat geprüft",
      transaction: {
        balancedWith: {
          description: "Vorgänge mit einem negativen Saldo werden automatisch durch zukünftige positive Salden ausgeglichen. Eine verbleibende positive Differenz wird überwiesen.",
          descriptionNegative: "negativer Saldo wurde um {amount} ausgeglichen.",
          descriptionPositive: "positiver Saldo wurde um {amount} ausgeglichen.",
          thisItem: "Dieser Vorgang",
          title: "verrechnet mit"
        },
        manual: {
          description: "Diese Transaktion wurde manuell von einem Benutzer durch Anklicken der Schaltfläche „Bezahlen“ durchgeführt.",
          title: "manuelle Zahlung"
        },
        migration: {
          description: "Dieser Vorgang wurde bezahlt, bevor die Zahlungsintegration eingerichtet wurde. Er wurde automatisch durch das System ausgeglichen.",
          title: "Legacy-Zahlung"
        },
        payment: {
          status: {
            canceled: "Erstattungen abgebrochen",
            completed: "Erstattung abgeschlossen",
            pending: "Erstattung ausstehend",
            processing: "Erstattungen in Bearbeitung"
          }
        },
        paymentService: {
          label: "Zahlungsdienst",
          values: {
            manual: "Manuell",
            odoo: "Odoo",
            qonto: "Qonto"
          }
        },
        reconciliation: {
          types: {
            bucket: "Verrechnet mit",
            other: "Mit einer anderen Transaktion verrechnet",
            payment: "Banküberweisung"
          }
        },
        refund: {
          description: "Es wurde zu viel bezahlt weil der Vorgang nach der Bezahlung storniert oder verändert wurde. Die Rückbuchung wird automatisch von zukünftigen Erstattungen abgezogen.",
          status: {
            canceled: "Rückbuchung abgebrochen",
            completed: "",
            pending: "Rückbuchung ausstehend",
            processing: "Rückbuchung in Bearbeitung"
          }
        }
      },
      transition: "Status",
      update: "Hat Details aktualisiert",
      updateExpenses: "Hat Spesen aktualisiert"
    },
    agent: "Geändert von „{agent}“ (KI-Assistent) im Auftrag von {name}",
    agentUnknown: "Geändert von einem KI-Assistenten im Auftrag von {name}",
    enterComment: "Geben Sie einen Kommentar ein",
    title: "Verlauf"
  },
  loggedInInfo: {
    enableAdminRole: "Adminrolle aktivieren",
    impersonate: "Impersonate",
    impersonating: "Impersonating",
    logout: "Abmelden",
    profile: "Profil",
    reports: "Report View",
    settings: "Einstellungen",
    signedInAs: "Angemeldet als"
  },
  login: {
    button: "Login",
    error: {
      code: "Fehlercode: {code}",
      description: "Bei der Anmeldung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut und wenden Sie sich an IT Ops mit dem unten angegebenen Fehlercode, falls das Problem weiterhin besteht.",
      title: "Anmeldung fehlgeschlagen",
      userNotRegistered: "Ihr Konto ist nicht bei MEREKO registriert. Bitte wenden Sie sich an IT Ops, um Zugriff zu erhalten."
    },
    welcome: "Willkommen, bitte melden Sie sich an"
  },
  maintenance: {
    adminBanner: "Der Wartungsmodus ist aktiv – normale Benutzer sind von der Anwendung ausgeschlossen.",
    description: "Die Anwendung ist derzeit im Wartungsmodus. Bitte versuchen Sie es später erneut.",
    startupDescription: "Die Anwendung wird derzeit aktualisiert. Sie ist in wenigen Augenblicken wieder verfügbar.",
    title: "Im Wartungsmodus"
  },
  milageAllowance: {
    startTyping: "Tippen, um einen Ort hinzuzufügen",
    subTitle: "Geben Sie die zurückgelegten Strecken ein, um die Kilometerpauschale zu berechnen",
    title: "Kilometerpauschale (Privatfahrzeug)"
  },
  navigationWidget: {
    backToOverview: "Zurück zur Übersicht",
    nextItem: "Nächster Vorgang {done}/{total}",
    nextReceipt: "Nächster Beleg",
    prevItem: "Zurück",
    previousReceipt: "Vorheriger Beleg",
    up: "Zurück zur Reise"
  },
  newReceipt: {
    create: "Beleg erstellen",
    pick: "Beleg auswählen",
    scan: "Beleg fotografieren",
    upload: "Beleg hochladen"
  },
  noReceiptsYet: {
    empty: "Beginnen Sie mit dem Hochladen eines Belegs",
    useDragNDrop: "Oder ziehen Sie eine Datei per Drag & Drop hinein",
    useScanner: "Benutzen Sie Ihre Kamera",
    useUpload: "Oder wählen Sie eine Datei aus"
  },
  oauthConsent: {
    accept: "Zugriff erlauben",
    deny: "Ablehnen",
    description: "{clientName} möchte in Ihrem Namen auf MEREKO zugreifen.",
    error: "Die Anfrage konnte nicht abgeschlossen werden. Bitte schließen Sie diese Seite und versuchen Sie es erneut.",
    scopes: {
      email: "Ihre E-Mail-Adresse anzeigen",
      mereko: "Ihre Reisen und Belege lesen und in Ihrem Namen in MEREKO handeln",
      offline_access: "Der Zugriff bleibt bestehen, bis Sie ihn widerrufen",
      openid: "Ihre Identität überprüfen",
      profile: "Ihr Basisprofil einsehen"
    },
    scopesLabel: "Die Anwendung wird Folgendes tun können:",
    title: "Anwendung autorisieren",
    unknownClient: "Unbekannte Anwendung"
  },
  ok: "Ok",
  outOfOffice: "Out of office",
  overview: {
    approvalsFor: "Genehmigungen für {name}",
    loadError: "Fehler beim Laden Ihrer Ausgaben:",
    noMatches: "Keine Treffer für Ihre Eingabe",
    othersExpenses: "{name}s Auslagen",
    total: "Offene Beträge",
    uploadError: "Fehler beim Hochladen eines neuen Belegs:",
    yourExpenses: "Ihre Auslagen"
  },
  participants: {
    company: "Firma",
    external: "Extern",
    name: "Name",
    startTyping: "Tippen, um Teilnehmer hinzuzufügen",
    subTitle: "Geben Sie Name und Firma für alle bewirteten Personen ein",
    title: "Teilnehmer"
  },
  profilePage: {
    approvers: "Genehmiger",
    colleagues: "Kollegen",
    displayName: "Anzeigename",
    email: "E-Mail",
    employeeId: "Mitarbeiternummer",
    managedEmployees: {
      direct: "Mitarbeiter",
      directSub: "Mitarbeiter (Vertretung)",
      indirect: "Mitarbeiter von Mitarbeitern",
      indirectSub: "Mitarbeiter von Mitarbeitern (Vertretung)"
    },
    manager: "Manager",
    personalInfo: "Persönliche Infos",
    profile: "Profil",
    roles: "Rollen"
  },
  receipt: "Beleg",
  receiptEditor: {
    addPage: "Seite hinzufügen",
    addSum: "Posten hinzufügen",
    "delete": "Seite löschen",
    download: "Seite herunterladen",
    header: "Beleg {receiptId}",
    inclTax: "Inkl {tax, number, percent} MwSt",
    noFile: "Keine Datei hochgeladen",
    pdfProcessing: "Die Verarbeitung von PDFs kann einige Sekunden dauern",
    rotate: "Seite um 90° nach rechts drehen",
    useScanner: "Benutzen Sie Ihre Kamera",
    useUpload: "Datei auswählen"
  },
  receiptType: {
    airlineticket: "Flugticket",
    boardingPass: "Bordkarte",
    creditCardVoucher: "Credit Card Voucher",
    customAdornment: "Benutzerdefinierter Typ",
    envelope: "Umschlag",
    expenses: "Spesen",
    gasoline: "Benzin",
    gasolineCompanyCar: "Benzin (Firmenwagen)",
    gasolineRentalCar: "Benzin (Mietwagen)",
    hotel: "Hotel",
    internet: "Internet",
    meal: "Mahlzeit",
    milageAllowance: "Kilometerpauschale (Privatfahrzeug)",
    otherreceipt: "Anderer Beleg",
    overnight: "Privatübernachtung",
    ownReceipt: "Eigenbeleg",
    parking: "Parken",
    publicTransportation: "Öffentliche Verkehrsmittel",
    rentalcar: "Mietauto",
    taxi: "Taxi",
    trainticket: "Zug-Ticket"
  },
  relations: {
    additionalApprover: "Zusätzlicher Genehmiger",
    manager: "Manager",
    substitute: "Stellvertreter"
  },
  report: {
    headers: {
      date: "Datum",
      employee: "Mitarbeiter",
      endedOn: "Rückkehr/Belegdatum",
      id: "Id",
      locationFrom: "Von",
      locationTo: "Nach",
      manager: "Manager",
      open: "Offen",
      paid: "Bezahlt",
      payableTotal: "Zahlbare Summe",
      startedOn: "Abreise",
      state: "Status",
      total: "Summe",
      type: "Art",
      updatedOn: "Aktualisiert am"
    },
    request: {
      download: "Herunterladen",
      error: "Beim Erstellen Ihres Berichts ist ein Fehler aufgetreten:",
      inProgress: "Ihr Report wird erstellt...",
      month: "Monat",
      noFiles: "Keine Dateien zum Herunterladen",
      pleaseSelect: "Bitte auswählen",
      ready: "Ihr Report steht zum Download bereit:",
      user: "Benutzer"
    },
    title: "Berichtsansicht",
    types: {
      receipt: "Beleg",
      trip: "Reise"
    }
  },
  retry: "Erneut versuchen",
  roles: {
    admin: "Admin",
    adminActive: "Admin (Aktiv)",
    backOffice: "Back Office",
    finance: "Finanzen"
  },
  save: "Speichern",
  scanner: {
    captureError: "Bild konnte nicht aufgenommen werden",
    deviceError: "Das Videogerät kann nicht verwendet werden",
    deviceNeedPermission: "Bitte erlauben Sie die Nutzung Ihrer Kamera",
    devicePermissionDenied: "Geräteberechtigung verweigert",
    noDevices: "Keine Kamera gefunden"
  },
  search: {
    archived: "Archivierte anzeigen",
    date: "Nach Datum filtern",
    directHits: "Direkte Treffer",
    keywords: "Schlüsselwörter (Ids, Beschreibungen, Reiseziele)",
    less: "Zeige weniger",
    more: "Zeige {count, number} mehr",
    ownerId: "Nach Benutzern filtern",
    placeholder: "Beginnen Sie zu Suchen und Filtern",
    receipt: "Beleg {id}",
    receiptType: "Filtern nach Belegtyp",
    recursive: "Indirekte Mitarbeiter anzeigen",
    selectDate: "Wählen Sie einen Zeitraum",
    selectLastMonth: "Letzten Monat",
    selectThisMonth: "Diesen Monat",
    state: "Filtern nach Status",
    trip: "Reise {id}"
  },
  settings: {
    additionalApprovers: "Zusätzliche Genehmiger",
    admin: "Admin-Einstellungen",
    autoArchive: "Bezahlte Vorgänge automatisch archivieren",
    general: "Allgemeine Einstellungen",
    language: "Sprache",
    languageAuto: "Auto",
    maintenance: {
      enable: "Wartungsmodus aktivieren",
      message: "Wartungsmeldung",
      messagePlaceholder: "Wird ausgesperrten Benutzern angezeigt. Für eine allgemeine Meldung leer lassen.",
      title: "Wartung"
    },
    notifications: "Benachrichtigungseinstellungen",
    notifyOwnEmail: "E-Mail für meine Belege",
    notifyRoleEmail: "E-Mail für andere Belege",
    notifySelf: "Bei Änderungen benachrichtigen, die ich selbst mache",
    payment: {
      description: "MEREKO benötigt Ihre Zahlungsinformationen, um Ihnen Ihre Auslagen zu erstatten.",
      iban: {
        description: "Ziel IBAN für Erstattungen",
        label: "IBAN"
      },
      paymentRecipient: {
        description: "Name des Zahlungsempfängers. Lassen Sie dieses Feld leer, um Ihren Benutzernamen zu verwenden.",
        label: "Zahlungsempfänger"
      },
      title: "Zahlungseinstellungen"
    },
    paymentSetup: {
      isConfigured: "Die Zahlungsintegration ist konfiguriert",
      notConfigured: "Die Zahlungsintegration ist nicht konfiguriert.",
      postBills: "Rechnungen automatisch posten",
      postBillsDescription: "Wenn diese Funktion deaktiviert ist, werden Rechnungen in {provider} als Entwürfe erstellt und müssen dort manuell geposted werden.",
      pullNow: "Zahlungsstatus von {provider} jetzt aktualisieren",
      pushNow: "Jetzt Zahlungen in {provider} erstellen",
      refreshlogin: "Anmeldung aktualisieren",
      setupBy: "Eingerichtet durch",
      setupOn: "Einrichtung am",
      setupPayment: "Zahlungsintegration einrichten",
      title: "Zahlungsintegration"
    },
    permissions: "Berechtigungen",
    settings: "Einstellungen",
    substitute: "Stellvertreter",
    system: {
      sync: "AD synchronisieren",
      title: "System"
    },
    testEmail: "Test-E-Mail senden"
  },
  stateWidget: {
    archive: "Vorgang archivieren.",
    cancel: {
      askConfirmation: "Sind Sie sicher, dass Sie {type, select, Beleg {diesen} Reise {diese}} {type} stornieren möchten?",
      commentPlaceholder: "(Optional) Grund für die Stornierung",
      description: "Stornierte Vorgänge bleiben aus Dokumentationsgründen im System gespeichert. Bereits erfolgte Zahlungen führen zu einem negativen Saldo.",
      label: "{type, select, Beleg {Diesen} Reise {Diese}} {type} stornieren",
      no: "Nein, behalten",
      yes: "Ja, stornieren."
    },
    "delete": {
      askConfirmation: "Sind Sie sicher, dass Sie {type, select, Beleg {diesen} Reise {diese}} {type} löschen möchten?",
      description: "Gelöschte Elemente werden endgültig aus dem System entfernt. Dieser Vorgang kann nicht rückgängig gemacht werden.",
      label: "{type, select, Beleg {Diesen} Reise {diese}} {type} löschen",
      no: "Nein, behalten",
      yes: "Ja, löschen"
    },
    moreActions: "Weitere Aktionen",
    payment: {
      missingPaymentDataTitle: "Fehlende Zahlungsinformationen"
    },
    reactivate: "Vorgang reaktivieren.",
    resetTo: "Zurücksetzen auf den Status „{state} “",
    state: "Status",
    waitingFor: "Warte auf"
  },
  stateWidgetChild: {
    relation: "{relation} von {ofUserName}",
    role: "Rolle {role}"
  },
  states: {
    approval: {
      forward: "Genehmigen",
      name: "Genehmigung"
    },
    canceled: {
      name: "Storniert"
    },
    clearing: {
      forward: "Clear",
      name: "Clearing"
    },
    closing: {
      forward: "Zahlungsbereit",
      name: "Closing"
    },
    completed: {
      name: "Bezahlt"
    },
    draft: {
      forward: "Einreichen",
      name: "Entwurf"
    },
    payment: {
      forward: "Bezahlen",
      name: "Zahlung"
    }
  },
  table: {
    deselectAll: "(Alle abwählen)"
  },
  tableView: {
    actions: "Aktionen",
    reports: "Reports",
    settings: "Einstellungen",
    transition: "Workflow-Status ändern",
    transitions: {
      approval: "{count, number} Vorgänge genehmigen",
      clearing: "{count, number} Vorgänge clearen",
      closing: "{count, number} Vorgänge schließen",
      draft: "{count, number} Vorgänge einreichen",
      payment: "{count, number} Vorgänge bezahlen"
    }
  },
  thisLanguage: "Deutsch",
  trip: "Reise",
  tripEditor: {
    addExistingReceipt: "Bestehenden Beleg hinzufügen",
    addReceipt: "Beleg hinzufügen",
    addSelectedReceipts: "Der Reise hinzufügen",
    create: "Reise anlegen",
    duplicate: "Neue Reise erstellen basierend auf dieser",
    empty: "Reise anlegen",
    header: "Reise {tripId}",
    processing: "Wird verarbeitet…",
    receipts: "Belege",
    selectReceipts: "Wählen Sie einen Beleg zum Hinzufügen",
    sumOpen: "Offene Auslagen",
    sumPaid: "Erstattete Kosten",
    uploading: "Upload {current, number}/{total, number}"
  },
  tripEditorNew: {
    chooseTemplate: "Informationen kopieren von...",
    header: "Reise anlegen"
  },
  tripListEntry: {
    emptpy: "Keine Belege",
    from: "Von {from}",
    newTrip: "Neue Reise",
    to: "Bis {to}",
    tripTo: "Reise nach {locationTo}"
  },
  validations: {
    hasDuplicatesUnacceptedByOwner: "Doppelte Belege vor dem Speichern entfernen oder akzeptieren.",
    hasDuplicatesUnreviewedByManager: "Doppelte Belege vor dem Speichern überprüfen",
    iban: "Ungültiges IBAN-Format",
    invalid: "Dieser Wert ist ungültig",
    receipt: {
      date: {
        bounds: "Das Datum muss während der Reise liegen"
      }
    },
    required: "\"{field}\" ist erforderlich",
    thereWereErrors: "Es gab Validierungsfehler",
    tripData: {
      endedOn: {
        bounds: "Das Rückkehrdatum muss nach der Abreise sein"
      }
    }
  },
  vehicleType: {
    car: "Auto",
    motorcycle: "Motorrad"
  }
} as const;
